document.addEventListener("alpine:init", () => {
    Alpine.data("PowerBackupForm", () => ({
      loading: false,
      step: 1,
      email: "",
      errMsg: "",
      success: false,
      disclaimerChecked: false,

      // Functions
      setStep(step) {
        this.step = step;
      },
      // Save email to alpine and pass to next step
      async submitResult() {
        const isEmailValid = validateEmail(this.email);
        if (!isEmailValid) {
          this.errMsg = "Please enter a valid email address.";
          return;
        }

        if (!this.disclaimerChecked) {
          this.errMsg = "Please agree to the Privacy Policy and Terms of Service..";
          return;
        }

        // If no error, remove error message
        this.errMsg = "";

        // getContactListId function in subscription-form-common.js
        const contactListId = getContactListId(PowerBackupFormSettingJsons);

        // Extract theme global variables from theme.liquid
        const { apiUrl, acceptedLanguage, apiKey, xAppid } =
          theme.emailSubscription;

        const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
        let eventTracking = null;

        if (subscribeInfoCookie) {
          try {
            const decodedCookie = decodeURIComponent(subscribeInfoCookie)
            eventTracking = JSON.parse(decodedCookie);
            delete eventTracking.ts
            console.log('eventTracking', eventTracking);
          } catch (error) {
            console.log('eventTracking error', subscribeInfoCookie);
            console.warn('Failed to parse subscribe_info cookie:', error);
          }
        };

        const apiBody = {
          email: this.email,
          contactListId,
          ...(eventTracking && { eventTracking }),
          fields: [
            {
              // Country field id: EU = 4427
              id: "11457",
              type: "single",
              value: 1,
              overwrite: true,
            },
            {
              id: "11461",
              type: "single",
              value: 1,
              overwrite: true,
            },
            {
              id: "11520",
              type: "multiple",
              value: [3],
              overwrite: true,
            }
          ],
        };

        this.loading = true;
        try {
          const response = await fetch(
            // Header global settings are defined in star-email-subscription-form.liquid
            // Except traceId is defined in subscription-form-common.js
            apiUrl,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                apiKey: apiKey,
                traceId: traceId,
                "X-appid": xAppid,
                "Accepted-Language": acceptedLanguage,
              },
              body: JSON.stringify(apiBody),
            }
          );

          const data = await response.json();

          console.log(data, "this is data from api");

          if (data.message === "Success") {
            this.success = true;
          }
        } catch (error) {
          this.errMsg =
            "Oops... Something went wrong, please refresh and try again.";
        } finally {
          this.loading = false;
        }
      }
    }));
  });
